import type { MustReadPageDto } from '~/types/hdapi';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const { isAuthenticated } = useAuth();
  const mustReadState = useState<MustReadPageDto[]>('must-read-pages', () => []);

  if (!isAuthenticated.value) {
    return;
  }

  // Only try to fetch if the state is empty
  if (mustReadState.value.length === 0) {
    const { data, error } = await useFetch('/api/must-read');
    if (error.value) {
      console.error('Error fetching must-read pages:', error.value);
    } else {
      mustReadState.value = data.value;
    }
  }

  //  Redirect if there are unread pages
  if (mustReadState.value.length > 0 && mustReadState.value.some(page => !page.userHasRead)) {
    if (to.path !== '/attention-required') {
      return navigateTo('/attention-required');
    }
  }
});
